import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { FirebaseTourModel } from '../data-model/tour.model';
import { FirebaseUserModel } from '../data-model/user.model';
import { AlertService } from '../services/alert.service';
import { AuthService } from '../services/auth.service';
import { DatabaseService } from '../services/database.service';
import { ProfileTypes } from '../utilities';

@Injectable({
  providedIn: 'root'
})
export class TourDetailGuard implements CanActivate {
  constructor(
    public auth: AuthService,
    private router: Router,
    public db: DatabaseService,
    public alert: AlertService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    const id = route.paramMap.get('id');
    const modo = route.paramMap.get('modo');
    console.log("Id y modo",id,modo);

    if (!id) { //Si no hay id en la ruta, estoy en creación
      return this.canUserCreateTour();
    }
    else if (id && modo=='edicion'){ //Si hay id en la ruta y está en modo Edición
      return this.canUserEditTour(id);
    }
    else if (id && modo=='vista'){ //Si hay id en la ruta y está en modo Vista
      return this.canUserViewTour(id);
    }
    else{ //Cualquier otro caso no válido
      this.alert.showAlert("Titulo","No tienes permisos para visitar esta página","error");
      return new Promise<boolean>((resolve,reject) => {resolve(false)});      
    }

  }

  async canUserCreateTour() {
    try {
      const user = await this.auth.getCurrentUserAlt();
      if (user) {
        const userData = await this.db.getUser(user.uid).get();
        if (userData) {
          const userModel = FirebaseUserModel.objectUserToModel(userData.data());
          if (userModel.profile == ProfileTypes.Creador) { //Si el perfil del usuario es creador entonces puede crear un tour
            return true;
          }
        }
      }
      this.alert.showAlert("Titulo","No tienes permisos para visitar esta página","error");
      return false;
    }
    catch (error) {
      this.alert.showAlert("Titulo","No tienes permisos para visitar esta página","error");
      return false;
    }
  }

  async canUserEditTour(id) {
    try {
      const user = await this.auth.getCurrentUserAlt();
      const tourData = await this.db.getTour(id).get().toPromise();
      if (user) {
        const userData = await this.db.getUser(user.uid).get();
        if (userData && tourData) {
          const userModel = FirebaseUserModel.objectUserToModel(userData.data());
          const tourModel = FirebaseTourModel.objectToModel(tourData.data());
          if (userModel.profile == ProfileTypes.Creador && tourModel.uid==user.uid){ //Si el usuario es el creador de ese tour entonces puede editarlo
            return true;
          }
        }
      }
      this.alert.showAlert("Titulo","No tienes permisos para visitar esta página","error");
      return false;
    }
    catch (error) {
      this.alert.showAlert("Titulo","No tienes permisos para visitar esta página","error");
      return false;
    }
  }

  async canUserViewTour(id){
    console.log('comprueba vista');
    try {
      const user = await this.auth.getCurrentUserAlt();
      const tourData = await this.db.getTour(id).get().toPromise();
      if (user) {
        const userData = await this.db.getUser(user.uid).get();
        if (userData && tourData) {
          const userModel = FirebaseUserModel.objectUserToModel(userData.data());
          const tourModel = FirebaseTourModel.objectToModel(tourData.data());
          if (userModel.profile == ProfileTypes.Creador && tourModel.uid==user.uid){ //Solo si el usuario es el creador de ese tour
            return true;
          }
          else if(tourModel.isPublished==true){ //Cualquier usuario siempre que el tour esté publicado
            return true;
          }
        }
      }
      this.alert.showAlert("Titulo","No tienes permisos para visitar esta página","error");
      return false;
    }
    catch (error) {
      this.alert.showAlert("Titulo","No tienes permisos para visitar esta página","error");
      return false;
    } 
  }

}
